import "../../index64.css";
import { jsx as o, jsxs as b } from "react/jsx-runtime";
import { _ as s } from "../../cs-piwRuCFZ.js";
import "../../type-BFTbooL7.js";
import T from "../BooleanOutput/index.js";
import w from "../DateOutput/index.js";
import N from "../NumberOutput/index.js";
import { DEFAULT_INVALID_TEXT as y } from "../../utils/constants.js";
const C = "_text-output_10oza_1", z = "_with-background_10oza_6", O = "_label_10oza_11", k = "_with-colon_10oza_12", B = "_value_10oza_17", D = "_text-type_10oza_18", L = "_strong_10oza_24", t = {
  textOutput: C,
  withBackground: z,
  label: O,
  withColon: k,
  value: B,
  textType: D,
  strong: L
};
function X(n) {
  const {
    className: c,
    label: i,
    icon: p,
    description: r,
    labelClassName: m,
    descriptionClassName: _,
    valueClassName: d,
    strongLabel: v,
    strongValue: h,
    strongDescription: g,
    withoutLabelColon: x,
    withBackground: f,
    invalidText: a = y,
    ...e
  } = n, { value: u } = n;
  let l = a;
  return e.valueType === "number" ? l = /* @__PURE__ */ o(
    N,
    {
      ...e,
      invalidText: a
    }
  ) : e.valueType === "date" ? l = /* @__PURE__ */ o(
    w,
    {
      ...e,
      invalidText: a
    }
  ) : e.valueType === "boolean" ? l = /* @__PURE__ */ o(
    T,
    {
      ...e,
      invalidText: a
    }
  ) : u instanceof Date || (l = u || a), /* @__PURE__ */ b(
    "div",
    {
      className: s(
        t.textOutput,
        f && t.withBackground,
        c
      ),
      children: [
        p,
        i && /* @__PURE__ */ o(
          "div",
          {
            className: s(
              t.label,
              v && t.strong,
              m,
              !x && t.withColon
            ),
            children: i
          }
        ),
        /* @__PURE__ */ o(
          "div",
          {
            className: s(
              t.value,
              h && t.strong,
              e.valueType === "text" && t.textType,
              d
            ),
            children: l
          }
        ),
        r && /* @__PURE__ */ o(
          "div",
          {
            className: s(
              t.description,
              g && t.strong,
              _
            ),
            children: r
          }
        )
      ]
    }
  );
}
export {
  X as default
};
